<script setup>
import {computed, ref} from "vue";
import {game} from "@/utils/config";
// import {kaoajiangStores, searchArea, searchCity} from "@/utils/module/mousuannai";
import router from "@/router";
import {shuangkeStores} from "@/utils/module/shuangke.json";
import {ArrowRight} from "@element-plus/icons-vue";

// const type = computed(() => game.mos)
const data = ref(shuangkeStores)

</script>

<template>
  <div class="page-stores">
    <div class="stores-header">
      <div class="back" @click="router.replace({name:'home'})">
        <el-icon>
          <ArrowLeft/>
        </el-icon>
      </div>
      <div class="title">爽客按摩椅适用网点</div>
      <div></div>
    </div>
    <el-scrollbar class="page-pid page-stores-lst">
      <div class="pages-store-lst-pro" v-for="(st,key) in data" :key="key">
        <div class="pro-name">
          <div>{{ key }}</div>
          <div @click="st.show = !st.show">
            <el-icon>
              <ArrowDown v-if="st.show"/>
              <ArrowRight v-else/>
            </el-icon>
          </div>

        </div>
        <div class="pages-store-lst-city" v-for="(ci,city) in st" :key="city" v-if="st.show">
          <div class="pro-name" v-if="city !== 'show'">
            <div>{{ city }}</div>
            <el-icon @click="ci.show = !ci.show">
              <ArrowDown v-if="ci.show"/>
              <ArrowRight v-else/>
            </el-icon>
          </div>
          <div class="pages-store-lst-area" v-for="(stores,inx) in ci" :key="inx" v-if="ci.show">
            <div class="pro-name" v-if="inx !== 'show'">
              <div>{{ inx }}</div>
              <el-icon @click="stores.show = !stores.show">
                <ArrowDown v-if="stores.show"/>
                <ArrowRight v-else/>
              </el-icon>
            </div>
            <div class="store-list" v-for="(store,i) in stores.data" :key="i" v-if="stores.show">
              <div class="store-info">
                <div class="store-name">
                  {{ store.address }}
                  <el-tag effect="plain">{{ store.area }}</el-tag>
                </div>
                <div class="store-address">
                  <el-text type="info">{{ store.address }}</el-text>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </el-scrollbar>
  </div>
</template>

<style scoped lang="less">
.page-stores {
  //background-color: #003615;
  height: 100vh;

  .stores-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 45px;
    box-sizing: border-box;
    padding: 0 15px;
  }

  .page-stores-lst {
    height: calc(100vh - 45px);
    padding: 0 15px;
    box-sizing: border-box;

    .pages-store-lst-pro {
      margin-bottom: 10px;
      line-height: 1.75;
      border: var(--el-border);
      box-sizing: border-box;
      padding: 0 5px;
      .pro-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
      }

      .pages-store-lst-city{
        padding-left: 10px;
        box-sizing: border-box;
      }
      .pages-store-lst-area{
        padding-left: 10px;
        box-sizing: border-box;

        .store-list{
          margin: 10px 0;
          font-size: .8rem;
          line-height: 2;
        }
      }
    }
  }
}
</style>
